import React, { useState } from "react";
// import "./Home.scss";
import Sidebar from "../components/sidebar/Sidebar";
import Navbar from "../components/navbar/Navbar";
import About from "../components/aboutme/About";
import Potfolio from "../components/potfolio/Potfolio";
import Hero from "../components/hero/Hero";
import Contact from "../components/contactme/Contact";
import Footer from "../components/footer/Footer";
import WorkFlow from "../components/workflow/WorkFlow";
import Skills from "../components/skills/Skills";

const Home = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="app">
      {isOpen ? <Sidebar toggle={toggle} /> : <Navbar toggle={toggle} />}
      <div className="section">
        <Hero />
        <About />
        <WorkFlow />
        <Skills />
        <Potfolio />
        <Contact />
        <Footer />
      </div>
    </div>
  );
};

export default Home;
